import {Component, Input, OnInit} from '@angular/core';
import {circles} from "../data.types";

@Component({
  selector: 'as-data-list',
  templateUrl: './data-list.component.html',
  styleUrls: ['./data-list.component.scss']
})
export class DataListComponent implements OnInit {

  @Input() data: Array<circles>;
  @Input() header: string;

  constructor() { }

  ngOnInit() {
  }
}
